// extracted by mini-css-extract-plugin
export default {"navItem":"NavItem_navItem__-mKst"};